import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import { IS_WIDGET_ENABLED } from "utils/WidgetUtil";
import { isLogoutPage } from "utils/Auth0Utils";
import {
  isSecurityEnabled,
  initUserService,
  isLoggedIn,
  login,
} from "./services/UserService";
import * as serviceWorker from "./serviceWorker";
import { registerSmartMerchandiser } from "./SMWidget";
import { registerGlobalRecordingFunctions } from "utils/AnalyticsRecordingUtils";

if (IS_WIDGET_ENABLED) {
  registerSmartMerchandiser();
}

registerGlobalRecordingFunctions();

const renderApp = () =>
  !IS_WIDGET_ENABLED &&
  ReactDOM.render(<App />, document.getElementById("root"));

(window as any).showUnimplemented = () => {
  window.localStorage.setItem("showUnimplemented", "true");
};
(window as any).hideUnimplemented = () => {
  window.localStorage.setItem("showUnimplemented", "false");
};

// Comment the below code to test Iframe implementation
if (isSecurityEnabled()) {
  initUserService().then(() => {
    const userLoggedIn = isLoggedIn();
    const isOnLogoutPage = isLogoutPage();
    // Don't auto-redirect to login if user is on logout page
    if (!userLoggedIn && !isOnLogoutPage) {
      login();
    } else {
      renderApp();
    }
  });
} else {
  renderApp();
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
